import { useEffect } from "react";
import { useInvoiceStore } from "../store";

export const usePresetVatPercentInformative = () => {
  const store = useInvoiceStore();

  useEffect(() => {
    store.calculateVAT();
  }, [store.sumInvoiceItems, store.sumProformaInvoices]);
};
